import { styled } from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { Card } from "@similarweb/ui-components";

import { AssetsService } from "app/services/AssetsService";

import { useDurationContext } from "../../contexts/DurationContext";

import { StateContainer } from "./StateContainer";

const IMG_HEIGHT = "270px";

const StyledImg = styled.img`
    height: ${IMG_HEIGHT};
`;

export const EndOfResultsState = () => {
    const { translate } = useTranslate();
    const duration = useDurationContext();

    const daysCount = duration.raw.to.diff(duration.raw.from, "day") + 1;

    return (
        <Card padding="44px 0">
            <StateContainer
                title={translate("platform.alerts.endOfResults.title")}
                subtitle={translate("platform.alerts.endOfResults.interval-subtitle", { count: daysCount })}
            >
                <StyledImg
                    src={AssetsService.assetUrl("images/activation-alerts/hourglass.png")}
                    alt={translate("platform.alerts.endOfResults.title")}
                    data-automation="end-of-results-image"
                />
            </StateContainer>
        </Card>
    );
};
